import axios from 'axios';
import {authHeader} from '../_helpers/auth-header';

//inteceptor로 빼서 처리하는 이유: authHeader()가  uploadApi호출때마다 업데이트되지 않기 때문
export const uploadApi = axios.create({
  headers: {
    'Content-Type': 'application/json'
  }
});

uploadApi.interceptors.request.use(
  (config) => {
    config.headers.Authorization = authHeader();
    return config;
  },
  (error) => {
    return Promise.reject('테스트 api 에러 :', error);
  }
);
